export const CHANGE_PASSWORD = 'Change Password';
export const PASSWORD_EXPIRY_NOTIFICATION_TEXT = 'Your password will expire in';
export const DAY = 'day';
export const DAYS = 'days';
export const SUBMIT_LABEL = 'Change it now';
